import { render, staticRenderFns } from "./SettingRanking.vue?vue&type=template&id=9d253414&"
import script from "./SettingRanking.vue?vue&type=script&lang=js&"
export * from "./SettingRanking.vue?vue&type=script&lang=js&"
import style0 from "./SettingRanking.vue?vue&type=style&index=0&id=9d253414&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports